export default {
    userDetails: {
        "avatar": "Profile photo",
        "verificationPhoto": "Verification photo",
        "photoUnavailable": "Unavailable or failed to load",

        loadingTags: 'Loading tags',
        "history": "Query history",
        "historyEmpty": "No saved queries yet.",
        "historyView": "View",
        "historyDelete": "Delete",
        "historyHint": "Stored in this browser, separately per manager. History shows a saved snapshot; use Search to refresh the data.",
        "historyRestored": "Loaded saved query (not live data):",
        "historySaved": "Saved to query history.",
        "historySaveFailed": "History was not saved: storage is full or unavailable. Delete old records and retry.",
        "historyReadFailed": "Cannot read query history. Stored data may be invalid or browser storage unavailable.",
        "historyDeleteFailed": "Could not delete this record. Retry.",
        "historyRegionUnavailable": "This record’s city is no longer manageable; it cannot be restored.",

        "title": "Duplicate user lookup",
        "intro": "Import a CSV to view complete member details in their original groups.",
        "file": "Choose CSV file",
        "help": "Requires Group (組別) and resumeID (or ID) columns. IDs always mean Resume IDs. Resolves UID in the selected city, then searches by UID for full details.",
        "search": "Search",
        "denied": "This feature is available to administrators only.",
        "ready": "Imported",
        "rows": "rows",
        "groups": "groups",
        "invalid": "Invalid CSV. Ensure every row has a group and resumeID.",
        "noCities": "Select a manageable country and city first.",
        "resolve": "Resolving UIDs",
        "details": "Loading member details",
        "done": "Search complete",
        "partial": "Search complete; some member details are unavailable. Check each entry.",
        "group": "Group",
        "missing": "Resume ID not found in this city, or UID missing",
        "unknown": "UID lookup incomplete; retry",
        "failed": "UID detail lookup failed; retry",
        "missingDetail": "UID search did not return this resume",
        "empty": "—",
        "country": "Country",
        "city": "City",
        "open": "Open in users page",
        "email": "Email",
        "introduction": "About",
        "gender": "Gender",
        "age": "Age",
        "actualAge": "Actual age",
        "language": "App language",
        "rating": "Rating",
        "signUps": "Sign ups",
        "remarks": "Notes",
        "tags": "Tags",
        "blacklist": "Blacklist level",
        "goodRates": "Good ratings",
        "needReverify": "Re-verification required",
        "tagWarning": "Tag names could not be loaded; showing tag IDs."
    },

    home: {
        "description": "Set up your workspace and get ready for today’s admin tasks.",
        "languageTitle": "Select language",
        "languageDescription": "Use your preferred language throughout the dashboard.",
        "trainingTitle": "Training Mode",
        "trainingDescription": "Practice with simulated data. Your practice does not change live records.",
        "trainingLabel": "Enable training mode",
        "agentsTitle": "Agents User Guide",
        "agentsDescription": "Set up your AI agent, start your first task, and copy the CRM prompt.",
        "agentsLink": "Open setup guide (繁體中文)"
    },
    agentGuide: {
        "routeTitles": {
            "agent/setup": "Agents User Guide",
            "login": "Sign in",
            "index": "Home",
            "users": "Members",
            "review": "Photo verification",
            "meetups": "Sessions and meet types",
            "group": "Groups and attendance",
            "restaurant": "Restaurants",
            "feedback": "Feedback",
            "feedback-ai-analysis": "AI feedback analysis",
            "notification": "Notifications",
            "notificationedit": "Edit notification",
            "edm": "Email templates",
            "edmedit": "Edit email",
            "EDMGenerator": "Email content editor",
            "promocode": "Promo codes",
            "promocodeedit": "Edit promo code",
            "billing": "Billing",
            "seasonpass": "Season passes",
            "countrycity": "Countries and cities",
            "manager": "Managers",
            "analyze": "Sign-up analysis",
            "userDetails": "Duplicate user lookup",
            "deeplink": "Deep links",
            "ai_gen": "Grouping AI",
            "modelinfo": "Grouping model reference",
            "highriskinfo": "Risk analysis reference",
            "high_risk_report": "Risk assessment report",
            "quicksetup": "Quick setup",
            "themetable": "Legacy theme tables",
            "themetableedit": "Legacy theme table editor"
        },
        "groupField": "Group {id}: {field}",
        "link": "agents guide",
        "skip": "Skip to main content",
        "navigation": "CRM navigation",
        "labels": {
            "session": "Session time",
            "restaurant": "Restaurant",
            "reservation": "Reservation name",
            "remarks": "Remarks",
            "model": "Grouping model",
            "locked": "Locked",
            "saveGroup": "Save group",
            "country": "Country",
            "city": "City",
            "date": "Meeting date",
            "startDate": "Start date",
            "endDate": "End date",
            "gender": "Gender filter",
            "signUps": "Sign-up count filter",
            "ageFilter": "Age filter",
            "rating": "Rating filter",
            "introduction": "Introduction filter",
            "blacklist": "Blacklist filter",
            "language": "Language filter",
            "nationality": "Nationality filter",
            "tagMode": "Tag filter mode",
            "account": "Account (email)",
            "password": "Password",
            "sidebar": "Collapse or expand navigation",
            "selectAll": "Select all members",
            "searchGroup": "Search group ID",
            "groupID": "Group ID",
            "destinationSession": "Destination session",
            "destinationCountry": "Destination country",
            "destinationCity": "Destination city",
            "search": "Search"
        }
    },
    quicksetup: {
        "title": "Quick setup — WKND Club CRM",
        "eyebrow": "Weekly operations",
        "heading": "Quick setup",
        "description": "Choose a session, group attendees, confirm bookings, and assign restaurants. Each step saves immediately; leaving or discarding a draft does not undo completed actions.",
        "context": "{city} / {time}",
        "stepMeet": "Select session",
        "stepGroup": "Group attendees",
        "stepRestaurant": "Confirm restaurants",
        "stepAssign": "Assign restaurants",
        "stepDone": "Complete",
        "stepOne": "Step 1",
        "stepTwo": "Step 2",
        "stepThree": "Step 3",
        "stepFour": "Step 4",
        "chooseMeetHeading": "Choose a session",
        "chooseMeetShortcut": "Choose a city and session",
        "country": "Country",
        "city": "City",
        "selectCountry": "Select a country",
        "selectCity": "Select a city",
        "startDate": "Start date",
        "endDate": "End date",
        "reloadMeets": "Load sessions",
        "continueGrouping": "Next: group attendees",
        "meetTime": "Meeting time",
        "deadline": "Registration deadline",
        "groupHeading": "Group attendees",
        "groupShortcut": "Check attendees, then group",
        "groupCount": "Groups",
        "groupedCount": "Grouped attendees",
        "ungroupedCount": "Ungrouped attendees",
        "promoSummary": "Exclude any promo codes?",
        "promoHelp": "Attendees using the selected promo codes are excluded from this grouping run.",
        "ungroupedNotice": "{count} attendees remain ungrouped. Check whether they need to be assigned.",
        "back": "Back",
        "keepGroups": "Keep existing groups",
        "runGrouping": "Run automatic grouping",
        "restaurantHeading": "Confirm restaurant bookings",
        "restaurantShortcut": "Choose one restaurant per group",
        "restaurantNeed": "Restaurants needed",
        "restaurantSelected": "Selected",
        "bookingHelp": "Arrange bookings yourself first. This step only records bookings in CRM; it does not contact restaurants.",
        "confirmRestaurants": "Confirm and record bookings",
        "assignHeading": "Review restaurant assignments",
        "assignShortcut": "Review assignments and finish",
        "assignHelp": "Suggestions minimize repeat visits using available dining history. Check capacity, attendee needs, and booking details before saving.",
        "group": "Group",
        "attendees": "Attendees",
        "restaurant": "Restaurant",
        "reservationName": "Reservation name",
        "repeatRisk": "Repeat visits",
        "status": "Status",
        "finish": "Save assignments and finish",
        "lockHelp": "Assignments save one group at a time and lock each group. Existing locked groups keep their settings.",
        "completeHeading": "Session setup complete",
        "completeDescription": "Booking records and group assignments are saved. Check the grouping page for any remaining ungrouped attendees.",
        "openGroups": "Open grouping",
        "openRestaurants": "Open restaurants",
        "startAnother": "Set up another session",
        "draftFound": "An unfinished setup was found",
        "resumeDraft": "Resume setup",
        "discardDraft": "Discard draft",
        "draftDescription": "City {city} / {time}",
        "draftDiscarded": "Local draft discarded. Saved groups and booking records remain unchanged.",
        "draftRestored": "Draft restored and checked against current data",
        "restoringDraft": "Restoring draft…",
        "draftMeetUnavailable": "The draft session is unavailable. Please select a session again.",
        "draftGroupsUnavailable": "Group data has changed. Please review the groups again.",
        "loadingMeets": "Loading sessions…",
        "noMeets": "No sessions in this date range",
        "openCityManager": "Open meeting management",
        "meetsLoaded": "Loaded {count} sessions",
        "selectCityFirst": "Select a city first",
        "selectDates": "Select start and end dates",
        "invalidDateRange": "End date must not precede start date",
        "loadMeetsFailed": "Unable to load sessions. Please retry.",
        "selectMeetFirst": "Select a session first",
        "loadingGroups": "Loading groups…",
        "groupsLoaded": "Group data refreshed",
        "loadGroupsFailed": "Unable to load groups. Please retry.",
        "needGroups": "Create groups first",
        "groupingInProgress": "Grouping attendees…",
        "groupingReturnedEmpty": "No groups were returned. Check the grouping page.",
        "groupingSuccess": "Grouping completed: {count} groups",
        "groupingFailed": "Grouping failed. Check current results before retrying.",
        "loadingRestaurants": "Loading restaurants…",
        "noRestaurants": "No restaurants are available",
        "restaurantsLoaded": "Loaded {count} restaurants",
        "loadRestaurantsFailed": "Unable to load restaurants. Please retry.",
        "noAddress": "No address",
        "alreadyBooked": "Booking recorded",
        "bookingFailed": "Booking record failed",
        "restaurantCountMismatch": "Select {count} restaurants, one per group.",
        "bookingInProgress": "Recording bookings…",
        "bookingPartialFailure": "Some booking records failed. Successful items are saved; retry the remaining items.",
        "bookingSuccess": "Booking records saved",
        "returnToAssignments": "Return to assignments",
        "noAssignments": "No restaurant assignments yet",
        "repeatCount": "{count} attendees visited before",
        "noRepeat": "No recorded repeat visits",
        "saved": "Saved",
        "saveFailed": "Save failed",
        "saving": "Saving…",
        "notSaved": "Not saved",
        "selectRestaurant": "Select a restaurant",
        "assignmentCountError": "Assignment count does not match the groups. Please review.",
        "assignmentRestaurantError": "Select a restaurant for every group",
        "assignmentReservationError": "Enter a reservation name for every group",
        "assignmentDuplicateError": "A restaurant cannot be assigned to multiple groups in this wizard. Please adjust.",
        "assignmentInvalid": "Check the restaurant assignments",
        "savingGroups": "Saving group assignments…",
        "groupSavePartialFailure": "Some group assignments failed. Successful items are saved; retry the remaining items.",
        "completeToast": "Quick setup complete",
        "completedGroups": "Completed groups",
        "completedPeople": "Assigned attendees",
        "completedRestaurants": "Assigned restaurants",
        "readFailed": "Unable to read data. Reload before continuing.",
        "lockedGroups": "Locked groups exist. Keep existing groups or use the grouping page to adjust them.",
        "changedData": "Groups or bookings have changed. Reload and review before saving.",
        "lockedConflict": "A locked group assignment cannot be preserved. Review it on the grouping page first.",
        "writeNotice": "This action saves immediately. Discarding a draft does not undo it.",
        "confirmRegroup": "Regrouping changes current unlocked groups. Continue?",
        "ambiguousMeet": "Multiple sessions share this city and time. The grouping API cannot distinguish them. Review them on the grouping page; quick setup cannot process this time yet.",
        "sessionClosed": "Disabled",
        "sessionStarted": "Meeting started",
        "storageFailed": "Local draft could not be saved. Keep this page open and allow browser storage.",
        "noCountries": "No manageable countries",
        "noCities": "No manageable cities",
        "scopeHelp": "This workflow operates on a city and meeting time. It does not create sessions."
},
    workspace: {
        presetAddWeek: "Add {week} {title}",
        presetThisWeek: "this week",
        presetNextWeek: "next week",
        presetMore: "More",
        presetMoreTitle: "All preset sessions",
        presetConfirmTitle: "New session details",
        presetCreate: "Add",

        editSession: 'Edit session',
        sessionThemeHintBefore: "If a table is missing, go to ",
        sessionThemeHintAfter: " to complete its English copy.",
        sessionTable: 'Table type',
        sessionDeadline: 'Registration deadline',
        sessionCapacity: 'Capacity',
        sessionLocaleCount: '{count} languages',

        newSession: "New session",
        sessionIntro: "Create one meeting session. Maintain App copy in table management.",
        sessionStepOne: "Step 1: Session details",
        sessionStepTwo: "Step 2: Confirm creation",
        sessionThemeHint: "If a table is missing, complete its English copy in table management.",
        sessionDate: "Meeting date",
        sessionTime: "Meeting time",
        sessionCityZone: "City and time zone",
        sessionPrecheck: "Checks before continuing",
        sessionCheckTheme: "Select a table to preview English and other available copy.",
        sessionCheckDeadline: "Registration deadline must be strictly before the meeting.",
        sessionCheckDuplicate: "Existing sessions with the same city, table and time will be flagged.",
        sessionSelectedTheme: "Selected table",
        sessionAppPreview: "App copy preview",
        sessionFinalCheck: "Checks before creation",
        sessionRequiredComplete: "Required fields are complete.",
        sessionBack: "← Back to edit",
        sessionDuplicateFound: "An active session with this city, table and time already exists. Reload the session list; duplicate creation is blocked.",
        sessionNoDuplicate: "No existing session with the same city, table and time was found.",

        appCityImages: 'App City Images',
        discountable: 'Discount eligibility',
        discountableHint: 'Choosing no discounts means no promo codes can be used for this table type.',
        discountAllowed: 'Discounts allowed',
        discountDenied: 'No discounts',
        inlineCopy: 'App copy (languages)',
        inlineAddLocale: 'Add language',
        inlineLocaleTooLong: 'Display titles are limited to 20 characters and descriptions to 200. Please shorten text that exceeds the limit.',
        inlineLocaleHelp: 'Language titles and descriptions may be blank; English copy is optional. Unchanged saved languages and completely blank new languages are not submitted. Saved languages cannot be removed. If saving partially fails, successful changes remain saved; retry the remaining items.',
        duplicateLocale: 'Each language can only be added once.',
        duplicateThemeType: 'This type already exists in this city. Use another name or edit the existing table.',
        themeLookupFailed: 'The table was created, but its ID could not be uniquely resolved. Retry lookup or reload the list to edit it. The table will not be created again.',
        themeScopeChanged: 'The city changed. Close and reopen the form.',
        localeSaveHint: 'Language copy saves separately. Cancelling table edits does not undo saved copy.',
        sessionStarted: 'Meeting started; editing is unavailable',
        returnToSession: 'Return to session draft',
        createThemeForSession: 'Create a table or complete its copy',
        draftSaveFailed: 'Unable to save the draft. Please allow browser local storage.',
        draftClearFailed: 'The session was created, but its local draft could not be cleared.',
        imageChecking: 'Pending check',
        imagePresent: 'Available',
        imageUnavailable: 'Missing / unavailable',

        backToCityList: 'Back to list',
        cityImageNotSet: 'Not set',
        cityImageUploadHint: 'Images upload immediately after file selection. Saving is not required; cancelling city edits does not undo an upload.',
        cityArea: 'District background (English)',
        cityAreaLocation: 'District background',
        uploadCityImage: 'Upload image',
        replaceCityImage: 'Replace image',
        invalidCityImage: 'Choose a valid image file and image type.',
        cityImageUploading: 'Uploading image. Please wait.',
        cityImageUploaded: 'Image uploaded',
        cityImageUploadFailed: 'Image upload failed. Please try again.',
        signUps: 'Sign-ups',
        registrationStatus: 'Registration status',
        sessionAvailable: 'Open for registration',
        sessionUnavailable: 'Disabled',
        signUpsUnknown: 'Sign-up count is unavailable. Removal is disabled.',
        sessionHasSignUps: 'This session has sign-ups and cannot be removed.',

        cityThumbnail: 'City thumbnail',
        cityBookingImage: 'City image',
        cityImageLoadFailed: 'Unable to load image',

        createCountryData: '+ Set up a new country',
        addCityDistrict: 'Add city / district',
        displayName: 'App display name', category: 'Category', missingEnglish: 'English copy missing', placeCount: 'Countries ({countries}) / Cities ({cities}) / Districts ({districts})',
    "meetings": "Meeting Management",
    "countries": "Countries and Cities",
    "themes": "Table Types",
    "searchPlaces": "Search countries, cities or districts",
    "editCountry": "Edit country",
    "currency": "Currency",
    "symbol": "Currency symbol",
    "status": "Status",
    "languageName": "Language name",
    "countryLanguageRequired": "Enter the language name and language code.",
    "languageCode": "Language code",
    "addLanguage": "Add language",
    "saveFailed": "Could not save. Please try again.",
    "saved": "Saved successfully",
    "languageExists": "This language already exists",
    "places": "Country / City / District",
    "invalidSession": "Complete the session details with a positive whole-number capacity",
    "invalidDeadline": "Registration must close before the meeting starts",
    "duplicateSession": "A session with this city, table type and time already exists",
    "englishRequired": "Enable this table type and complete its English title and description first",
    "createSession": "Create session",
    "next": "Next: review and confirm",
    "back": "Back to edit",
    "arrange": "Schedule session",
    "searchThemes": "Search App display names",
    "addBrunchType": "+ Add brunch type",
    "addTeaType": '+ Add afternoon tea type',
    "themeTemplateDetails": 'New themed table details',
    "templateKnowledge": '1 (Knowledge)',
    "templateSharing": '2 (Sharing)',
    "addBookType": "+ Add bookworm type",
    "allStatuses": "All statuses",
    "allTypes": "All table types",
    "addBrunchSession": "+ Add brunch this week",
    "addBookSession": "+ Add bookworm this week",
    "missingTemplate": "Create and enable a matching table type with English copy first",
    "unsaved": "You have unsaved changes. Leave anyway?"
},
    deeplink: {
        "seasonLocation": "Choose a season-pass location (otherwise use the current app location)",
        "directHelp": "Enter an existing event ID. The app loads purchase details by ID without location or time conditions.",
        "meetTimeID": "Event ID (meetTimeID)",
        "directPurchase": "Direct purchase by event ID",
        "title": "DeepLink",
        "instructionsTitle": "DeepLink Instructions",
        "introLink": "Fixed link: every DeepLink uses the existing OneLink: wkndclub.onelink.me/66q3.",
        "introPid": "pid (media source): identifies the link source; use a preset or custom value, and provide it every time.",
        "introValue": "Destinations: season_pass accepts no location or all of sub1–sub3; booking_checkout is themed-table/brunch checkout, with brunch fixed to meetTypeID=1. Direct purchase sends only pid and meetTimeID, without other routing conditions.",
        "introCountry": "deep_link_sub1 (countryID): the country ID; the country can be selected freely.",
        "introCity": "deep_link_sub2 (cityID): the upper-level city ID used by the app.",
        "introDistrict": "deep_link_sub3 (districtID): the service location or district ID; for cities without districts, it equals cityID.",
        "introTheme": "deep_link_sub4 (meetTypeID): the themed-table type ID.",
        "introSlot": "deep_link_sub5 (specific time): the event time in specific-time mode, formatted as yyyyMMddHHmmss; next-bookable mode omits this parameter.",
        "introFlag": "deep_link_sub10: fixed to 1 for season-pass and conditional checkout links; unnecessary for direct purchase by event ID.",
        "introRules": "Only cities with coming=0 are offered. Exact mode searches on date changes; end must follow start. Missing event IDs, expired events and duplicate times are excluded; choose one time button.",
        "introApp": "App behavior: nearest mode resolves the next valid event at opening; unavailable or ambiguous exact times return to booking. The app revalidates data and eligibility; purchase links are ignored during payment.",
        "introLimits": "Time and limits: times use the event location’s timezone; logged-out users only open the app. This tool creates links only; it does not create orders or process payments.",
        "action": "Destination",
        "season": "Season pass purchase",
        "brunch": "Brunch checkout",
        "booking": "Themed table checkout",
        "source": "Media source (pid)",
        "custom": "Custom",
        "customSource": "Custom media code",
        "country": "Country",
        "city": "City",
        "district": "District",
        "theme": "Themed table",
        "mode": "Date mode",
        "nearest": "Next bookable event",
        "exact": "Specific time",
        "start": "Start date",
        "end": "End date",
        "slot": "Event time",
        "choose": "Select an option",
        "copy": "Copy link",
        "testLink": "Test link",
        "copied": "Link copied",
        "copyFailed": "Automatic copy failed. Select and copy the link below.",
        "preview": "Link preview",
        "ready": "Link ready",
        "incomplete": "Complete the required selections to generate a link.",
        "loading": "Loading…",
        "api": "Unable to load data. Select again or retry.",
        "denied": "DeepLink is only available to administrators with auth = 1.",
        "retry": "Reload locations",
        "timezone": "Event timezone",
        "unknownTimezone": "A valid event timezone is required to load specific times.",
        "range": "Enter a valid date range (the end date must be later than the start date; maximum 366 days).",
        "noBrunchSlots": "There are currently no brunch sessions.",
        "noThemeSlots": "This themed table currently has no available times.",
        "noThemes": "No available themed tables in this district.",
        "noCities": "No matching cities in this country.",
        "noCountries": "No countries available.",
},
    languageName: 'English',

    // Common elements
    common: {
        welcome: 'Welcome',
        login: 'Login',
        logout: 'Logout',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        create: 'Create',
        search: 'Search',
        submit: 'Submit',
        back: 'Back',
        close: 'Close',
        add: 'Add',
        menu: 'Menu',
        copy: 'Copy',
        copied: 'Copied',
        copyfailed: 'Copy failed',
        download: 'Download',
        processing: 'Processing...',
        saving: 'Saving...',
        loading: 'Loading...',
        refresh: 'Refresh',
        regularphoto: 'Regular Photo',
        verificationphoto: 'Verification Photo',
        emailcopied: 'Email copied',
        clear: 'Clear',
        nodata: 'No data'
    },

    // Navigation
    nav: {
        quicksetup: "Quick setup",
        userDetails: 'Duplicate user lookup',
        deeplink: 'DeepLink',
        photoverification: 'Photo Verification',
        groups: 'Grouping',
        feedback: 'Feedbacks',
        users: 'Users',
        restaurant: 'Restaurants',
        administrator: 'Administrator',
        citymanagement: 'City Management',
        messagesnotifications: 'Notifications',
        promocode: 'Promo Code',
        themetable: 'Themed Table',
        seasonpass: 'Season Pass',
        billing: 'Accounts',
        analyze: 'Analytics',
        edm: 'EDM',
        systememail: 'System Email'
    },

    analyze: {
        title: 'WKND Club CMS - Analytics',
        permissionDenied: 'This page is only available to managers with authorization = 1.',
        filterSection: 'Analytics Filters',
        startDate: 'Start Date',
        endDate: 'End Date',
        sort: 'Sort',
        sortApi: 'API Order',
        sortHigh: 'Sign-ups High to Low',
        sortLow: 'Sign-ups Low to High',
        signUpListTab: 'Sign-up List',
        weeklyTrendTab: 'Weekly Trend',
        period: 'Period',
        periodSixMonths: 'Six Months',
        periodOneYear: 'One Year',
        reload: 'Reload',
        chartType: 'Chart Type',
        chartTypeLine: 'Line',
        chartTypeSmoothLine: 'Smooth Line',
        chartTypeArea: 'Area',
        cityFilter: 'Visible Cities',
        order: 'Order',
        country: 'Country',
        city: 'City',
        districts: 'Districts',
        signUps: 'Sign-ups',
        summary: 'Cities ({cityCount}) / Sign-ups ({signUps})',
        weeklySummary: '{weekCount} weeks / Cities ({cityCount}) / Sign-ups ({signUps})',
        weeklyCacheSummary: 'Cached {cached} weeks / Fetched {fetched} weeks',
        weeklyLoading: 'Loading weekly trend {current}/{total}',
        weeklyEmpty: 'No weekly trend data found.',
        empty: 'No sign-up data found for this date range.',
        dateRequired: 'Please select a start date and an end date.',
        invalidDateRange: 'Start date cannot be later than end date.',
        loadFailed: 'Unable to load analytics data.'
    },

    citymanager: {
        title: 'WKND Club CMS - City Management',
        meetTimesTab: 'Actual Sessions',
        citySettingsTab: 'City Settings',
        loadingCountries: 'Loading countries...',
        noCountries: 'No countries available',
        selectCountry: 'Select Country',
        selectCity: 'Select City',
        noCitiesForCountry: 'No cities available for this country',
        selectCityFirst: 'Please select a city first.',
        reload: 'Reload',
        dateRequired: 'Please select a start date and an end date.',
        invalidDateRange: 'Start date cannot be later than end date.',
        loadingMeetTimes: 'Loading meet times...',
        loadedMeetTimes: 'Loaded {count} meet times',
        loadMeetTimesFailed: 'Unable to load meet times.',
        meetTimesSummary: 'Meet Times ({count})',
        noMeetTimes: 'No meet times found for this date range.',
        addMeetTime: 'Add Time',
        updateMeetTime: 'Edit Session',
        meetTimeDetails: 'Meet Time Details',
        meetTime: 'Meet Time',
        deadline: 'Deadline',
        tableType: 'Table Type',
        spots: 'Spots',
        spotsRequired: 'Please enter the number of spots.',
        meetTimeRequired: 'Please enter both meet time and deadline.',
        meetType: 'Themed Table',
        defaultMeetTypeName: 'Brunch Table',
        loadingMeetTypes: 'Loading themed tables...',
        loadMeetTypesFailed: 'Unable to load themed tables.',
        noMeetTypes: 'No themed tables are available for this city.',
        meetTypeRequired: 'Please select a themed table.',
        addMeetTimeSuccess: 'Meet time added.',
        addMeetTimeFailed: 'Failed to add meet time.',
        updateMeetTimeSuccess: 'Session updated.',
        updateMeetTimeFailed: 'Failed to update session.',
        updateMeetTimeNeedsID: 'This row is missing cityMeetTimeID and cannot be updated.',
        deadlineRequired: 'Please enter a deadline.',
        removeMeetTime: 'Delete Session',
        removeMeetTimeConfirmTitle: 'Delete the following session?',
        confirmRemoveMeetTime: 'Confirm Delete',
        removeMeetTimeSuccess: 'Meet time removed.',
        removeMeetTimeFailed: 'Failed to remove meet time.',
        removeNeedsID: 'This row is missing cityMeetTimeID and cannot be removed.',
        cityMeetTimeID: 'ID',
        actions: 'Actions',
        remove: 'Remove',
        loadCountriesFailed: 'Unable to load city data.',
        loadCountriesFallback: 'All Cities API failed. Using locally manageable city data.',
        initializationFailed: 'Failed to initialize City Management.',
        citySettingsSummary: 'Cities ({count})',
        noCities: 'No city data found.',
        addCity: 'Add City',
        editCity: 'Edit City',
        createCity: 'Create City',
        updateCity: 'Update City',
        saveCitySuccess: 'City settings saved.',
        saveCityFailed: 'Failed to save city settings.',
        requiredCityFields: 'Please fill country, city, district, timezone, price, payment gateway, and main language.',
        missingCityID: 'Missing cityID. Unable to update city.',
        country: 'Country',
        cityID: 'City ID',
        cityName: 'City',
        districts: 'Districts',
        timezoneName: 'Timezone',
        timezonePlaceholder: 'Search timezone, e.g. Australia/Perth',
        timezoneHelp: 'Search by city or region, e.g. Australia/Perth.',
        showTimezoneOptions: 'Show timezone options',
        noTimezoneResults: 'No matching timezones found',
        invalidTimezone: 'Please select a valid IANA timezone, e.g. Australia/Perth.',
        price: 'Price',
        seasonPrice: 'Season Price',
        seasonReps: 'Season Reps',
        taxRate: 'Tax Rate',
        discounted: 'Discounted',
        promoCode: 'Promo Code',
        firstUsePromoUnmatched: 'No matching promo ID',
        unresolvedFirstUsePromo: 'The first-use promo code could not be matched to a valid promoCodeID. The original value is preserved and nothing was submitted. Select a promo code, or reopen the city editor and try again.',
        firstUsePromo: 'First-use Promo Code',
        selectFirstUsePromo: 'Select promo code',
        noFirstUsePromoConfigured: 'No promo codes configured',
        loadingPromoCodes: 'Loading promo codes...',
        loadFirstUsePromoFailed: 'Failed to load first-use promo codes.',
        support: 'Support',
        gateway: 'Payment Gateway',
        gatewayStripeNative: 'Stripe native payment',
        gatewayStripeCheckout: 'Stripe hosted payment (Checkout)',
        gatewayTapPay: 'TapPay',
        presale: 'Presale',
        presaleOn: 'On',
        presaleOff: 'Off',
        available: 'Open Status',
        availableOpen: 'Open',
        availableClosed: 'Not Open',
        availableRecruiting: 'Franchise Recruiting',
        mainLang: 'Main Lang'
    },

    cityMeetTimeRules: {
        pageHeading: 'Meet Time Rules',
        loadingCountries: 'Loading countries...',
        noCountries: 'No countries available',
        selectCity: 'Select City',
        noCitiesForCountry: 'No cities available for this country',
        selectCityFirst: 'Please select a city first.',
        reload: 'Reload',
        loadingRules: 'Loading meet time rules...',
        loadedRules: 'Loaded {count} meet time rules',
        loadRulesFailed: 'Unable to load meet time rules.',
        rulesSummary: 'Meet Time Rules ({count})',
        noRules: 'No meet time rules found for this city.',
        addMeetTimeRule: 'Add Meet Time',
        editMeetTimeRule: 'Edit Rule',
        updateMeetTimeRule: 'Update Rule',
        meetTimeRuleID: 'Rule ID',
        weekly: 'Interval (weeks)',
        weeklyHelp: '(For example, 1 means the meetup occurs every week; 2 means it occurs every two weeks, and so on.)',
        day: 'Day',
        dayHelp: 'The day of the week when the meetup occurs.',
        startTime: 'Start Time',
        endTime: 'End Time',
        deadlineMinutes: 'Deadline (minutes)',
        deadlineMinutesHelp: 'Close registration this many minutes before the event starts.',
        ruleAvailable: 'Status',
        ruleEnabled: 'Enabled',
        ruleDisabled: 'Disabled',
        daySunday: 'Sunday',
        dayMonday: 'Monday',
        dayTuesday: 'Tuesday',
        dayWednesday: 'Wednesday',
        dayThursday: 'Thursday',
        dayFriday: 'Friday',
        daySaturday: 'Saturday',
        ruleRequired: 'Complete the interval, day, start time, end time, and deadline minutes.',
        missingRuleID: 'Missing rule ID. Unable to update.',
        addRuleSuccess: 'Meet time rule added.',
        addRuleFailed: 'Failed to add meet time rule.',
        updateRuleSuccess: 'Meet time rule updated.',
        updateRuleFailed: 'Failed to update meet time rule.',
        actions: 'Actions',
        loadCountriesFailed: 'Unable to load city data.',
        loadCountriesFallback: 'All Cities API failed. Using locally manageable city data.',
        initializationFailed: 'Failed to initialize Meet Time Rules.'
    },

    // Zodiac Signs
    zodiac: {
        aries: 'Aries',
        taurus: 'Taurus',
        gemini: 'Gemini',
        cancer: 'Cancer',
        leo: 'Leo',
        virgo: 'Virgo',
        libra: 'Libra',
        scorpius: 'Scorpius',
        sagittarius: 'Sagittarius',
        capricornus: 'Capricornus',
        aquarius: 'Aquarius',
        pisces: 'Pisces'
    },

    // EDM
    edm: {
        all: 'All',
        systemEdm: 'System EDM',
        marketingEdm: 'Marketing EDM',
        name: 'Name',
        description: 'Description',
        status: 'Status',
        lastmodified: 'Last Modified',
        actions: 'Actions',
        subject: 'Subject',
        content: 'Content',
        statusOptions: {
            active: 'Active',
            inactive: 'Inactive'
        },
        addVersion: {
            title: 'Add Version',
            country: 'Country',
            city: 'City',
            type: 'EDM Type',
            language: 'EDM Language',
            cancel: 'Cancel',
            confirm: 'Confirm',
            button: 'Add Version'
        },
        type: 'Type',
        language: 'Language',
        version: 'Version',
        active: 'Active',
        inactive: 'Inactive',
        preview: 'Preview',
        edit: 'Edit'
    },

    // EDM Edit
    edmEdit: {
        sampleTemplate: 'Sample Template (Read-only)',
        editableContent: 'Editable Content',
        typeVersion: 'Type: {type}  |  Version: {version}',
        back: 'Back',
        preview: 'Preview',
        testSend: 'Send Test Email',
        submit: 'Submit',
        submitSuccess: 'Submitted successfully',
        submitFailed: 'Submit failed: {error}',
        testSendSuccess: 'Test email sent',
        testSendFailed: 'Send failed: {error}'
    },

    // EDM Edit Page (Metadata / EDM settings)
    edmEditPage: {
        sections: {
            settingsTitle: 'Email Settings',
            contentTitle: 'Content Editing'
        },
        fields: {
            type: { label: 'Type', placeholder: 'Select' },
            version: { label: 'Version Name', placeholder: 'Enter version name' },
            country: { label: 'Locations', placeholder: 'Select country', empty: 'No locations selected' },
            language: { label: 'Language' },
            subject: { label: 'Subject', placeholder: 'Enter subject', limitHint: 'Max 150 characters' },
            testTime: { label: 'Time', placeholder: 'Select time' },
            testLocation: { label: 'Location', placeholder: 'Enter location (optional)' },
            testAddress: { label: 'Address', placeholder: 'Enter address (optional)' },
            testLink: { label: 'Link', placeholder: 'Enter link (optional)' },
            testReservation: { label: 'Reservation Info', placeholder: 'Enter reservation info (optional)' }
        },
        actions: {
            editContent: 'Edit Email Content',
            testSend: 'Send Test Email'
        },
        preview: {
            title: 'EDM Preview',
            loading: 'Loading preview...',
            error: 'Failed to load preview',
            empty: 'Email content not created yet'
        },
        tags: {
            empty: 'No items yet'
        },
        history: {
            confirmClear: 'Clear all history records?'
        },
        toasts: {
            missingEdmID: 'Missing edmID, cannot load EDM data',
            missingEdmIDEdit: 'Missing edmID, cannot edit content',
            missingEdmIDSave: 'Missing edmID, cannot save',
            loadTypesFailed: 'Failed to load EDM types',
            loadDetailFailed: 'Failed to load EDM data',
            requiredFields: 'Please fill in type and version name',
            subjectTooLong: 'Subject cannot exceed 150 characters',
            saveSuccess: 'Saved successfully',
            saveFailed: 'Save failed',
            testSendUnknown: 'Send failed, please try again'
        }
    },

    // EDM Generator
    edmGenerator: {
        toasts: {
            missingEdmID: 'Missing edmID, cannot save',
            saveSuccess: 'Saved successfully',
            saveFailed: 'Save failed',
            saveFailedWithReason: 'Save failed: {error}'
        }
    },

    // EDM Edit - Test Send Offcanvas
    testSend: {
        title: 'Send Test Email',
        sendingInfo: 'Sending Info',
        name: 'Name',
        namePlaceholder: 'Enter name',
        email: 'Email',
        emailPlaceholder: 'Enter email',
        sendTime: 'Meet Time',
        edmTestInfo: 'EDM Test Info',
        cancel: 'Cancel',
        confirmSend: 'Send',
        sending: 'Sending...',
        sentSuccess: 'Sent',
        sendHistory: 'Send History',
        clearHistory: 'Clear History',
        errors: {
            nameRequired: 'Please enter name',
            emailRequired: 'Please enter email',
            emailInvalid: 'Invalid email format'
        }
    },

    // Dashboard
    dashboard: {
        title: 'Dashboard',
        summary: 'This is where the main content will be displayed.',
        recentActivity: 'Recent Activity'
    },

    // Language selection
    language: {
        select: 'Select Language',
        current: 'Current Language',
        changeSuccess: 'Language changed',
        zh_Hant: 'Traditional Chinese',
        en: 'English',
        ko: 'Korean',
        de: 'German',
        ja: 'Japanese'
    },

    // Filter
    filter: {
        selectcountry: 'Select Country',
        selectcity: 'Select City',
        selecttime: 'Select Time',
        selectmonth: 'Select Month',
        customdaterange: 'Custom Range',
        dateto: 'to',
        selectcountryfirst: 'Please select a country first',
        nomanageablecities: 'No manageable cities for this country'
    },

    // Groups
    groups: {
        creatingGroup: 'Creating group, please wait…',
        movingAttendee: 'Moving attendee, please wait…',
        savingGroup: 'Saving group, please wait…',
        savingGroupReason: 'Saving group reasons, please wait…',
        groupingAttendees: 'Grouping attendees, please wait…',
        movingSession: 'Changing session, please wait…',
        movingCity: 'Changing city, please wait…',
        cancellingAttendee: 'Cancelling attendance, please wait…',
        refundingAttendee: 'Processing refund, please wait…',
        savingRating: 'Saving rating, please wait…',
        savingVerification: 'Saving photo verification, please wait…',
        savingTags: 'Updating tags, please wait…',
        savingRiskAnalysis: 'Saving risk analysis, please wait…',
        savingAttendee: 'Updating attendee details, please wait…',

        loadingSession: 'Loading session data, please wait…',
        automaticgrouping: 'Automatic Grouping',
        aiAutomaticGrouping: 'AI Automatic Grouping',
        aiGrouping: 'AI Features & Grouping',
        autoGroupingDescription: 'Run automatic grouping for the currently selected session.',
        aiGroupingDescription: 'Runs automatic grouping, reloads attendee data, creates and saves AI tags, runs and saves batch group assessment, then completes and saves attendee risk assessment. This has multiple steps, so please wait patiently while it completes.',
        cancelGroupingDescription: 'Close this dialog without running any grouping flow.',
        addgroup: 'Add Group',
        modalInfoButton: 'Modal Info',
        grouped: 'Grouped',
        ungrouped: 'Ungrouped',
        reservationconfirmed: 'Booked',
        people: 'People',
        total: 'Total of',
        genderMale: 'Male',
        genderFemale: 'Female',
        genderNonBinary: 'Non-binary',
        selectrestaurant: 'Select Restaurant',
        arrangeLogic: 'Arrangement Logic',
        reservationname: 'Reservation Name',
        note: 'Note',
        enternote: 'Enter note',
        modelInfoTitle: 'Model Info',
        modelInfoDescription: 'View details of grouping models',
        modelId: 'Model ID',
        modelName: 'Model Name',
        modelDetails: 'Model Details',
        noModels: 'No model data available',
        modelLoadFailed: 'Failed to load model data',
        excludepromocode: 'Please select the Promo Code to exclude',
        used: 'Used',
        currentuserid: 'Current User UID',
        enteruserid: 'Please Enter UID',
        resendnotification: 'Resend Notification',
        refund: 'Refund',
        refundconfirmation: 'Are you sure you want to refund {userName}?',
        cancelandrefund: 'Cancel and refund',
        cancelandrefundconfirmation: 'Are you sure you want to cancel and refund {userName}?',
        emailcountlabel: 'Email List (Total {count})',
        noemailsfound: 'No emails found matching your criteria.',
        emailcopiedsuccess: 'Emails copied to clipboard!',
        emailcopiederror: 'Failed to copy emails to clipboard.',
        nocontenttocopy: 'No emails to copy.',
        nocontenttodownload: 'No emails to download.',
        emaildownloadedsuccess: 'Downloaded email list ({count} emails).',
        emailListModalTitle: 'Email List',
        emailListGroupIdPlaceholder: 'Search GroupID',
        emailListButton: 'Email List',
        // Alert text displayed at the bottom of the modal when ungrouped < 50
        ungroupedLessThan50Alert: 'Fewer than 50 ungrouped attendees cannot trigger the optimal algorithm',
        // Move city functionality
        movetime: 'Move Time',
        movecity: 'Move City',
        moveschedulecity: 'Change Region',
        movescheduletime: 'Change Time',
        user: 'User',
        attendingregion: 'Attending Region',
        currenttime: 'Current Time',
        availabletime: 'Available Time',
        from: 'From',
        moveto: 'Change To',
        confirmmove: 'Confirm Change',
        partnerInOtherGroupTooltip: 'This user\'s table partner was placed in group {groupId}',
        groupDescriptionButton: 'Group Description'
    },

    // AI Generator
    aiGen: {
        title: 'AI (beta)',
        featureButton: 'AI Features',
        description: 'Show grouped and ungrouped data for the selected time slot',
        featureTitle: 'AI Tools',
        modelMethodLockedTitle: 'Production mode always uses Gemini',
        createTags: 'Create Tags',
        applyModel: 'Group Assessment',
        batchApplyModel: 'Batch Group Assessment',
        batchActionEvaluate: 'Batch AI Evaluation',
        batchActionEvaluating: 'Running AI',
        batchActionSave: 'Batch Save',
        batchActionSaving: 'Saving',
        batchAgeUnit: ' yrs',
        batchProcessing: 'Processing batch group assessment',
        batchEvaluating: 'Running batch AI assessment',
        batchSaving: 'Saving batch descriptions',
        batchToolbarHint: '{count} groups will be processed serially for AI assessment and saving',
        batchGroupTitle: 'Group {index} (meetGroupID: {groupId} · bookedTime: {bookedTime})',
        batchEvaluateSummary: 'AI assessment complete: {successCount} succeeded, {failureCount} failed',
        batchEvaluateSuccessToast: 'Batch AI assessment complete: {successCount} succeeded',
        batchEvaluateFailureToast: '{failureCount} groups failed during batch AI assessment. Please review the status.',
        batchSaveSummary: 'Save complete: {successCount} succeeded, {failureCount} failed',
        batchSaveSuccessToast: 'Batch save complete: {successCount} succeeded',
        batchSaveFailureToast: '{failureCount} groups failed during batch save. Please review the status.',
        batchSaveReloadConfirm: 'Batch save is complete. Reload the page to refresh the displayed data?',
        batchStatus: {
            pending: 'Pending',
            evaluating: 'Evaluating {current}/{total}',
            evaluated: 'Evaluated',
            evaluateFailed: 'Evaluation Failed',
            saving: 'Saving {current}/{total}',
            saveSkipped: 'Skipped (No Description)',
            saved: 'Saved',
            saveFailed: 'Save Failed'
        },
        batchSummary: {
            modelNumber: 'Model Number: ',
            modelName: 'Model Title: ',
            confidence: 'Confidence: ',
            reasonTitle: 'Evaluation Highlights:',
            cautionTitle: 'Cautions:'
        },
        batchTooltip: {
            name: 'Name',
            email: 'Email',
            gender: 'Gender',
            age: 'Age',
            sign: 'Sign',
            rate: 'Rate',
            mbti: 'MBTI',
            lang: 'Language',
            nationality: 'Nationality',
            occupation: 'Occupation',
            resumeID: 'resumeID',
            previousSignUps: 'Previous Sign-ups',
            promoCode: 'Promo Code',
            dietaryHabit: 'Dietary Habit',
            repeatPeople: 'Repeat People',
            repeatRestaurant: 'Repeat Restaurant',
            visitedRestaurant: 'Visited Restaurant',
            recentRestaurant: 'Recent Restaurant',
            restaurantRating: 'Restaurant Rating',
            locationName: 'Location',
            reservationName: 'Reservation',
            remarks: 'Remarks',
            birthdate: 'Birthdate',
            group: 'Group',
            meetGroupID: 'meetGroupID',
            bookedTime: 'bookedTime',
            unknownUser: 'Unknown User',
            unknownTag: 'Unknown Tag',
            noDetails: 'No details available yet'
        },
        batchErrors: {
            noAttendees: 'This group has no attendee data',
            invalidJson: 'The AI response could not be parsed as JSON',
            missingGroupId: 'Missing groupID, unable to update the group description'
        },
        tagModal: {
            generateAction: 'Run AI Tags',
            importAction: 'Import Tags to Database',
            candidateListTitle: 'Users to Tag',
            userTagsTitle: 'User Tags',
            debugToggle: 'Show AI Prompt / Response',
            emptyHint: 'Click "Run AI Tags" to generate tags',
            promptEmpty: 'No prompt yet',
            resultEmpty: 'No response yet',
            emptyList: 'No tag data yet',
            systemMessage: 'System Message',
            table: {
                user: 'User',
                recommendedTags: 'AI Recommended Tags'
            },
            unknownUser: 'Unknown User',
            unknownTag: 'Unknown Tag',
            noTag: 'None',
            itemPrefix: 'Item',
            parseFailed: 'Parse Failed',
            noRecommendedTags: 'No recommended tags',
            noMatchingTags: 'No matching tags',
            searchTagsPlaceholder: 'Search tags...',
            importingStatus: 'Importing data',
            generatingStatus: 'Generating AI tags',
            examplePrompt: 'Sample Prompt',
            promptLogLabel: 'Prompt #{index} ({participant})',
            responseLogLabel: 'Response #{index} ({participant})',
            retryPromptLabel: 'Retry Prompt ({participant})',
            retryResponseLabel: 'Retry Response ({participant})',
            noResponseShort: 'No response',
            callFailedPrefix: 'Call failed: {message}',
            retryingItems: 'Retrying {count} failed items...',
            retryFailedPrefix: 'Retry failed: {message}',
            retryErrorRaw: 'An error occurred during retry',
            missingCityForImport: 'Missing city information; unable to import tags',
            noImportableData: 'No AI tag data available to import',
            importFailed: 'Failed to import tags. Please try again later.',
            tagAddFailed: 'Failed to add tag',
            tagRemoveFailed: 'Failed to remove tag',
            selectCityFirst: 'Please select a city first',
            addTagFailed: 'Failed to add tag: {tagName}',
            tagAdded: 'Tag added: {tagName}',
            addCityTagFailed: 'Failed to add city tag',
            updateTagFailed: 'Failed to update tag',
            removeTagFailed: 'Failed to remove tag'
        },
        applyModelModal: {
            evaluateAction: 'Run AI',
            descriptionSectionTitle: 'Group Description',
            copySuccess: 'Copied to clipboard',
            copyManualFail: 'Copy failed. Please select and copy manually.',
            saveProcessing: 'Saving...',
            saved: 'Saved',
            descriptionSaved: '{language} group description saved',
            updateFailed: 'Failed to update group description',
            noAttendees: 'This group has no attendee data',
            missingBlock: 'Unable to find the target group section',
            evaluatingStatus: 'Running group assessment',
            resultTitle: 'Assessment Result',
            parseFailed: 'The AI response could not be parsed as JSON. Please review the log below.',
            descriptionTitle: 'Group Description:',
            reasonTitle: 'Evaluation Highlights:',
            cautionTitle: 'Cautions:',
            logTitle: 'Log',
            copyAction: 'Copy',
            noResponse: 'No result returned from AI',
            evaluateFailed: 'Group assessment failed: {message}',
            groupTitleByIndex: 'Group {index}',
            groupTitleById: 'Group {groupId}'
        },
        country: 'Country',
        city: 'City',
        district: 'District',
        datetime: 'Date & Time',
        aiModel: 'AI model',
        userList: 'User List',
        groupedTitle: 'Grouped',
        ungroupedTitle: 'Ungrouped',
        missingParams: 'Missing city or time parameters. Please open from the Group page.',
        loadFailed: 'Failed to load data',
        missingApiKey: 'OpenRouter API key is not set.',
        permissionDenied: 'Insufficient permission to use this feature',
        noParticipants: 'No participant data available.',
        noCityTags: 'No city tags available.',
        generating: 'Generating...',
        generated: 'Done (Reasoning tokens: {tokens})',
        noResponse: 'No response from AI.',
        generateFailed: 'AI generation failed',
        applyModelPending: 'Group assessment is not available yet.',
        noGroupedData: 'No grouped data yet.',
        modalTitle: 'AI Tag Generator',
        highRisk: 'Risk Assessment',
        highRiskModalTitle: 'Risk Assessment',
        highRiskModal: {
            runAction: 'Run Risk Assessment',
            downloadAction: 'Download Report',
            userListTitle: 'User List',
            emptyHint: 'Click "Run Risk Assessment" to start',
            emptyList: 'No risk data yet',
            generatingStatus: 'Marking with AI',
            downloadNeedRunFirst: 'Please complete the AI risk assessment before downloading the report',
            runFailed: 'Risk assessment failed. Please try again later.',
            detailAction: 'Details',
            reportOpenFailed: 'Unable to open the risk assessment report',
            table: {
                name: 'Name',
                tags: 'Tags',
                introduction: 'Introduction',
                feedback: 'Feedback',
                risk: 'Risk Assessment'
            },
            feedback: {
                likes: 'Likes',
                normals: 'Normal',
                noShows: 'No-show',
                lates: 'Late',
                dislike: 'Negative',
                raterName: 'Name',
                remarks: 'Remarks'
            },
            noFeedback: 'No feedback',
            feedbackLoading: 'Loading feedback',
            feedbackLoadFailed: 'Failed to load feedback',
            unknownUser: 'Unknown User',
            parseFailed: 'Parse Failed',
            pending: 'Pending'
        },
        highRiskDetail: {
            headers: {
                category: 'Category',
                item: 'Item',
                value: 'Value'
            },
            categories: {
                analysis: 'Analysis',
                interest_tags: 'Interest Tags',
                risk: 'Risk',
                quality_score: 'Quality Score',
                recommended_action: 'Recommended Action',
                blacklist_assessment: 'Blacklist Assessment',
                tag_assessment: 'AI Tag Assessment',
                user_rating_assessment: 'Actual Event Feedback',
                final_assessment: 'Final Assessment'
            },
            fields: {
                analysis: {
                    language_style: 'Language Style',
                    social_vibe: 'Social Vibe',
                    analysis: 'Analysis'
                },
                interest_tags: {
                    tagItemPrefix: 'Tag',
                    display_tag: 'Display Tag',
                    normalized_category: 'Normalized Category',
                    social_attribute: 'Social Attribute',
                    items: 'Tag Items'
                },
                risk: {
                    detected_flags: 'Detected Flags',
                    reason: 'Reason',
                    risk: 'Risk'
                },
                quality_score: {
                    quality_score: 'Quality Score'
                },
                recommended_action: {
                    recommended_action: 'Recommended Action'
                },
                blacklist_assessment: {
                    level: 'Blacklist Level',
                    is_blacklisted: 'Blacklisted',
                    severity: 'Severity',
                    risk_score: 'Risk Score',
                    recommended_action: 'Recommended Action',
                    reason: 'Reason'
                },
                tag_assessment: {
                    severity: 'Tag Severity',
                    risk_score: 'Tag Risk Score',
                    negative_tags: 'Tag Negative Items',
                    neutral_or_positive_tags: 'Tag Neutral / Positive Items',
                    manual_risk_tags: 'Tag Special Rules',
                    reason: 'Tag Reason'
                },
                user_rating_assessment: {
                    has_data: 'Has Rating Data',
                    severity: 'Rating Severity',
                    risk_score: 'Rating Risk Score',
                    confidence: 'Confidence',
                    summary: 'Summary',
                    positive_signal: 'Positive / Normal Signal',
                    negative_signal: 'Negative Signal',
                    recommended_action: 'Recommended Action',
                    reason: 'Rating Reason'
                },
                final_assessment: {
                    '風險值': 'Risk Score',
                    '風險總評': 'Risk Summary',
                    severity: 'Severity',
                    recommended_action: 'Recommended Action',
                    top_risk_sources: 'Top Risk Sources',
                    decision_factors: 'Decision Factors'
                }
            }
        },
        promptTitle: 'Prompt Sent to AI',
        resultTitle: 'AI Response',
        table: {
            groupId: 'Group ID',
            location: 'Location',
            reservation: 'Reservation',
            name: 'Name',
            uid: 'UID',
            email: 'Email',
            gender: 'Gender',
            tags: 'Tags'
        }
    },

    // Toast Messages
    toasts: {
        // Group related toasts
        group: {
            groupnotfound: 'Group {groupNumber} not found',
            modalnotfound: 'Modal for location not found',
            groupedtotal: 'Grouped (Total {totalPeople} people)',
            visitedrestaurantsfor: 'Visited Restaurants for {userName}',
            recentlocationfor: 'Recent Location for {userName}',
            novisitedrestaurants: 'No visited restaurants recorded.',
            user: 'User',
            selectcity: 'Please select a city',
            selectdateandtime: 'Please select date and time',
            loaddataerror: 'A serious error occurred while loading data, please check the console',
            promocodeformaterror: 'Error reading promo code format',
            promocodefailed: 'Failed to read promo codes: {error}',
            cannotgetcitydatetime: 'Cannot get city, date or time for automatic grouping',
            selectedpromocodes: 'Selected {count} promo codes, executing automatic grouping...',
            nopromocodes: 'No promo codes selected, executing automatic grouping...',
            algogroupsuccess: 'Automatic grouping request successful! Refreshing data...',
            algogroupfailed: 'Automatic grouping failed: {error}',
            modalnotinitialized: 'Automatic grouping dialog cannot be opened, please try again later',
            cannotloadpromocodelist: 'Cannot load promo code list to dialog',
            nopromocodesavailable: 'Currently no promo codes available for selection.',
            updateungroupederror: 'Error updating ungrouped data: {error}',
            fetchlocationserror: 'Error fetching assignable locations: {error}',
            updategroupederror: 'Error updating grouped data: {error}',
            selectcitytoload: 'Please select a city to load/update data',
            selectdatetimetoload: 'Please select date and time to load/update data',
            selectcityforpromo: 'Please select a city first to load promo codes.',
            algogrouploading: 'Using algorithm for grouping, please wait patiently.',
            assignfailed: 'Assignment operation failed but no error was thrown',
            assignunknownerror: 'Unknown error occurred during assignment',
            cancelrefundsuccess: 'Refund request submitted for {userName}.',
            cannotgetrestaurants: 'Cannot get assignable restaurants, please try again later',
            creategroupfailednoqn: 'Failed to create new group: Server did not return a valid group number',
            creategroupsuccess: 'New group created successfully!',
            creategroupfailed: 'Failed to create new group: {error}',
            updategroupsuccess: 'Successfully updated group {groupNumber} data',
            updategroupfailed: 'Failed to update group {groupNumber} data, please try again later',
            updategrouperror: 'Error updating group {groupNumber} data: {error}',
            duplicaterestaurant: 'This restaurant is selected by another group in the same city and time, including other table types. Please choose a different restaurant.',
            restaurantCheckFailed: 'Could not verify restaurant usage across all table types at this city and time. Nothing was saved. Please retry.',
            restaurantScopeChanged: 'The selected session changed. Nothing was saved. Please retry in the current session.',
            grouplockedcannotassign: 'Group is locked, cannot assign item',
            selectrestaurantforlockedgroup: 'Please select a restaurant before locking the group',
            noassignablerestaurants: 'No assignable restaurants available. Please go to the restaurant page to select booking time',
            moveschedulecitysuccess: 'Successfully moved schedule to new city',
            moveschedulecityfail: 'Failed to move schedule to new city',
            movescheduletimesuccess: 'Successfully moved schedule to new time',
            movescheduletimefail: 'Failed to move schedule to new time'
        },
        // API related toasts
        api: {
            notloggedin: 'Not logged in or login expired'
        },
        // Restaurant related toasts
        restaurant: {
            namerequired: 'Restaurant name is required',
            addressrequired: 'Restaurant address is required',
            googlemapsrequired: 'Google Maps link is required',
            linktoolong: 'Restaurant link cannot exceed 100 characters',
            updatesuccess: 'Restaurant information updated successfully!',
            addsuccess: 'Restaurant added successfully!',
            updatefailed: 'Update failed. Please try again later.',
            addfailed: 'Add failed. Please try again later.',
            timeslotadded: 'Time slot added successfully!',
            timeslotaddfailed: 'Failed to add time slot.',
            timeslotadderror: 'Error adding time slot: {error}',
            timeslotremoved: 'Time slot removed successfully!',
            timeslotremovefailed: 'Failed to remove time slot.',
            timeslotremoveerror: 'Error removing time slot: {error}'
        },
        // Users related toasts
        users: {
            selectcityfirst: 'Please select a city first',
        tagremovesuccess: 'Tag "{tagName}" has been successfully removed from user',
        tagremovefailed: 'Failed to remove tag from user.',
        tagremoveerror: 'Error removing tag: {error}',
        tagupdatefailed: 'Failed to update tag.',
        tagupdateerror: 'Error updating tag: {error}',
        tagaddsuccess: 'Tag "{tagName}" has been successfully added to user',
            tagaddfailed: 'Failed to add tag to user.',
            tagadderror: 'Error adding tag: {error}',
            nocityselected: 'No city selected, cannot add tag.',
            newtagrequested: 'Tag "{tagName}" has been requested for addition. Updating list...',
            newtagfailed: 'Failed to add tag "{tagName}". Server did not confirm.',
            newtagfailederror: 'Failed to add tag "{tagName}": {error}',
            saveoperationerror: 'Save operation error, please refresh the page.',
            missingnoteid: 'Cannot save note: missing user ID.',
            noteupdated: 'Note has been updated!',
            noteupdatefailed: 'Note update failed.',
            noteupdateerror: 'Note update failed: {error}',
            selectcityforexport: 'Please select a city first to export email list.',
            emailformatincorrect: 'Cannot get email list, incorrect response format.',
            noemailstoexport: 'No emails to export under current filter conditions.',
            emailexportsuccess: 'Successfully exported {count} emails.',
            emailexportfailed: 'Email export failed: {error}',
            loadcitytagsfailed: 'Unable to load city tags: {error}'
        },
        selectcity: 'Please select a city',
        selectdate: 'Please select a date',
        selecttime: 'Please select a time',
        unknownerror: 'Unknown error',
        promocode: {
            invalidDiscountValue: 'Invalid discount value',
            promoCodeExists: 'Promo code already exists',
            addFailed: 'Failed to add promo code',
            promoCodeRequired: 'Please enter promo code',
            promoCodeTooLong: 'Promo code cannot exceed 15 characters',
            countryRequired: 'Please select country',
            expirationRequired: 'Please select expiration date',
            usageLimitInvalid: 'Usage limit per account must be greater than 0',
            totalQuantityInvalid: 'Total quantity must be greater than 0',
            percentageRangeInvalid: 'Percentage discount value must be between 1-100',
            discountFormatInvalid: 'Invalid discount format. Only numbers with up to 2 decimal places are allowed'
        },
        themetable: {
            invalidDiscountValue: 'Invalid price value',
            codeExists: 'Themed table code already exists',
            addFailed: 'Failed to add themed table',
            codeRequired: 'Please enter themed table code',
            codeTooLong: 'Themed table code cannot exceed 15 characters',
            countryRequired: 'Please select country',
            expirationRequired: 'Please select expiration date',
            usageLimitInvalid: 'Usage limit per account must be greater than 0',
            totalQuantityInvalid: 'Total quantity cannot be less than 0',
            percentageRangeInvalid: 'Percentage price must be between 1-100',
            discountFormatInvalid: 'Invalid price format. Only numbers with up to 2 decimal places are allowed'
        }
    },

    // API Error messages
    apiError: {
        sessionExpired: 'Not logged in or login expired. Please log in again.',
        missingCityID: 'Missing cityID parameter.',
        apiCallFailed: 'API call failed with status: {status} {statusText}',
        missingResumeEmails: 'Missing cityID for resume emails.',
        missingCityTags: 'Missing cityID for city tags.',
        missingCityTagParams: 'CityID and tagName are required for adding a city tag.',
        addCityTagFailed: 'Failed to add city tag due to an API error.',
        missingUpdateCityTagParams: 'TagID and tagName are required for updating a city tag.',
        updateCityTagFailed: 'Failed to update city tag due to an API error.',
        missingRemoveCityTagParams: 'TagID is required for removing a city tag.',
        removeCityTagFailed: 'Failed to remove city tag due to an API error.',
        missingResumeTagParams: 'ResumeID and tagID are required for adding a resume tag.',
        addResumeTagFailed: 'Failed to add resume tag due to an API error.',
        missingRemoveTagParams: 'ResumeID and tagID are required for removing a resume tag.',
        removeResumeTagFailed: 'Failed to remove resume tag due to an API error.',
        missingAgeParams: 'ResumeID and age are required for updating actual age.',
        invalidAge: 'Age must be a non-negative integer.',
        updateAgeFailed: 'Failed to update resume actual age due to an API error.',
        missingResumeID: 'ResumeID is required for updating remarks.',
        emptyRemarks: 'Remarks parameter is null or undefined, sending as empty string.',
        updateRemarksFailed: 'Failed to update resume remarks due to an API error.',
        missingUid: 'UID is required for fetching resume ratings.',
        missingRatingParams: 'ResumeID and rating are required for rating a resume.',
        invalidRating: 'Rating must be an integer between 1 and 5.',
        rateResumeFailed: 'Failed to rate resume due to an API error.',
        missingVerificationID: 'ResumeID is required for marking verification failed.',
        setVerificationFailedError: 'Failed to mark verification failed due to an API error.',

        // Error codes
        error: {
            '10010': 'Sign up not closed yet, unable to update',
            '10011': 'Group ID not found',
            '10012': 'Group is locked',
            '10013': 'Group city is different from the user\'s registered city',
            '10014': 'Group time is different from the user\'s registered time',
            '10015': 'User has been grouped, unable to cancel',
            '10040': 'Notification\'s send time has passed. Cannot update it anymore.',
            '10050': 'EDM is in use, unable to update'
        },
        
        // Restaurant API error messages
        missingCityIDForRestaurant: 'CityID is required for restaurant operations.',
        restaurantHttpError: 'HTTP error! status: {status}',
        updateLocationError: 'Failed to update location information.',
        addLocationError: 'Failed to add new location.',
        
        // Login API error messages
        missingCredentials: 'Email and password are required.',
        loginHttpError: 'Login failed. HTTP error! status: {status}',
        fetchCitiesError: 'Failed to fetch manageable cities. HTTP error! status: {status}',
        
        // Group API error messages
        groupHttpError: 'HTTP error! status: {status}',
        algoGroupFailed: 'Unable to create suitable groups from the current attendee data.',
        updateRestaurantFailed: 'Failed to update restaurant.',
        updateReservationFailed: 'Failed to update reservation name.',
        assignmentFailed: 'Assignment failed.',
        unknownAssignmentError: 'Unknown error occurred during assignment.',
        invalidGroupID: 'Unable to get a valid group ID.',
        invalidBookedValue: 'Invalid booked value. Must be 0 (not booked) or 1 (booked).',
        invalidLockedValue: 'Invalid locked value. Must be 0 (not locked) or 1 (locked).',
        updateGroupInfoFailed: 'Failed to update group information.',
        unknownGroupUpdateError: 'Unknown error occurred during group update.',
        cancelRefundFailed: 'Refund failed.',
        moveScheduleCityFailed: 'Failed to move schedule city.',
        moveScheduleFailed: 'Failed to move schedule time.',
        
        // Feedback API error messages
        feedbackHttpError: 'Failed to fetch feedback data. HTTP error! status: {status}',
        feedbackStatsError: 'Failed to fetch feedback statistics. HTTP error! status: {status}',
        feedbackLocationsError: 'Failed to fetch feedback locations. HTTP error! status: {status}'
    },

    // Restaurant
    restaurant: {
        add: 'Add',
        edit: 'Edit',
        update: 'Update',
        name: 'Restaurant Name (Max 45 characters)',
        address: 'Address',
        link: 'Link (Max 100 characters)',
        accessible: 'Accessible',
        yes: 'Yes',
        no: 'No',
        addrestaurant: 'Add Restaurant',
        editrestaurant: 'Edit Restaurant',
        replies: 'Replies',
        approvalrate: 'Approval Rate',
        food: 'Food',
        service: 'Service',
        price: 'Price',
        all: 'All',
        liked: 'Liked',
        disliked: 'Disliked',
        people: 'people',
        selectcityfirst: 'Please select a city first.',
        cannotloaddata: 'Cannot load restaurant data for',
        cityselectornotfound: 'City selector not found, cannot load restaurants.',
        saturday: 'Sat',
        sunday: 'Sun',
        positive: 'Positive',
        negative: 'Negative',
        bookedtimes: 'Booked Times'
    },

    // Feedback
    feedback: {
        overallactivityfeedback: 'Overall verall experience feedback rate',
        overalltrend: 'Overall Trend',
        responserate: 'Response rate',
        positiverate: 'Positive feedback rate',
        negativerate: 'Negative feedback rate',
        userfeedback: 'Feedbacks between users',
        noshowrate: 'No-show rate',
        laterate: 'Late arrival rate',
        restaurantfeedback: 'Restaurant feedback',
        recommendrate: 'Recommend rate',
        notrecommendrate: 'Don\'t recommend rate',
        evaluateandratedboth: 'Rating/Reviewed/All Displayed',
        evaluate: 'Reviewed',
        rated: 'Rating',
        negativereview: 'Negative',
        noshow: 'No-Show',
        notrecommend: 'Don\'t recommend',
        negativeornoshowfilter: 'Please select',
        clear: 'Clear',
        givenevaluation: 'User gave reviews to',
        notrecommendtofriends: 'Reasons for not recommending to friends',
        like: 'Like',
        dislike: 'Dislike',
        normal: 'Normal',
        late: 'Late',
        noevaluationdata: 'No evaluation data',
        clicktocopyuid: 'Click to copy UID',
        clicktoviewuser: 'Click to view user',
        restaurantselecterror: 'Error updating restaurant select',
        selectrestaurant: 'Select restaurant',
        noreasonprovided: 'Not recommended but no reason provided',
        otherreasons: 'Other Reasons',
        aiweeklyanalysis: 'AI Weekly Feedback Analysis'
    },

    feedbackAiAnalysis: {
        title: 'AI Feedback Analysis',
        backToFeedback: 'Back',
        pageDescription: 'Feedback and statistics are loaded from the current filters first. Choose current-week or multi-week comparison after the data is ready.',
        filterScope: 'Analysis scope',
        analysisMode: 'Analysis mode',
        weeklyMode: 'Current-week analysis',
        multiWeekMode: 'Multi-week comparison',
        weeklyModeHelp: 'Uses the latest week in the selected date range as the current week, compared with the previous week and 4-week average.',
        multiWeekModeHelp: 'Analyzes weekly averages, trends, volatility, and turning points across the full selected date range.',
        dataStatus: 'Data status',
        metricOverview: 'Current week metrics',
        multiWeekOverview: 'Multi-week overview',
        evidenceOverview: 'Evidence summary',
        aiAnalysis: 'AI analysis result',
        runAnalysis: 'Run AI analysis',
        rerunAnalysis: 'Run again',
        copyResult: 'Copy result',
        loadingData: 'Loading data',
        dataReady: 'Data ready',
        dataFailed: 'Data load failed',
        missingRequiredFilters: 'City or date range is missing. Analysis data cannot be loaded.',
        noData: 'There is not enough data to analyze for the current filters.',
        emptyState: 'Data is ready. Run AI analysis manually when needed.',
        analyzing: 'AI is analyzing weekly feedback',
        analyzingMultiWeek: 'AI is analyzing multi-week feedback',
        analysisFailed: 'AI analysis failed. Please try again later.',
        copied: 'Analysis result copied',
        city: 'City',
        dateRange: 'Date range',
        groupID: 'Group ID',
        uid: 'UID',
        feedbackType: 'UID mode',
        negativeFilter: 'Negative filter',
        restaurant: 'Restaurant',
        all: 'All',
        currentMode: 'Current mode',
        currentWeek: 'Current week',
        previousWeek: 'Previous week',
        fourWeekAverage: '4-week average',
        delta: 'Delta',
        weekOf: 'Week',
        mainChange: 'Main change',
        recommendRate: 'Recommend rate',
        notRecommendRate: 'Don\'t recommend rate',
        userPositiveRate: 'User positive rate',
        userNegativeRate: 'User negative rate',
        restaurantPositiveRate: 'Restaurant positive rate',
        restaurantNegativeRate: 'Restaurant negative rate',
        feedbackRows: 'Feedback rows',
        groups: 'Groups',
        restaurants: 'Restaurants',
        attendeeReviews: 'User reviews',
        statsWeeks: 'Stats weeks',
        analysisWeeks: 'Analysis weeks',
        dateRangeDays: 'Date range days',
        latestWeek: 'Latest week',
        averageRecommendRate: 'Average recommend rate',
        averageNotRecommendRate: 'Average don\'t recommend rate',
        mostVolatileMetric: 'Most volatile metric',
        biggestChange: 'Largest single-week change',
        weekCountSummary: '{count} stats weeks',
        noPreviousWeek: 'No previous week',
        evidenceScope: 'Evidence scope',
        weeklyEvidenceScope: 'Using feedback evidence from week {week}: {count} rows',
        weeklyEvidenceScopeFallback: 'Feedback rows could not be reliably mapped to week {week}; using full-range evidence: {count} rows',
        multiWeekEvidenceScope: 'Using feedback evidence from the full selected date range: {count} rows',
        topNotReferReasons: 'Not-recommend reasons',
        topUserNegativeTags: 'User negative tags',
        topLocationNegativeTags: 'Restaurant negative tags',
        representativeComments: 'Representative comments',
        noEvidence: 'No text or tag evidence is available.',
        summary: 'Analysis summary',
        trendSummary: 'Trend summary',
        turningPoints: 'Turning points',
        keyFindings: 'Key findings',
        metricAnalysis: 'Metric analysis',
        rootCauseHypotheses: 'Root-cause hypotheses',
        recommendedActions: 'Recommended actions',
        followUpQuestions: 'Follow-up questions',
        limitations: 'Limitations',
        rawResponse: 'Raw AI response',
        evidence: 'Evidence',
        confidence: 'Confidence',
        whyItFits: 'Why it fits',
        gap: 'Gap',
        nextCheck: 'Next check',
        reason: 'Reason',
        owner: 'Owner',
        successSignal: 'Success signal'
    },

    // Users
    users: {
        uidSearch: 'Enter UID to search',
        emailList: 'Email List',
        gender: 'Gender',
        male: 'Male',
        female: 'Female',
        signups: 'Sign-ups',
        times0: '0 times',
        times1: '1 time',
        times2: '2 times',
        times3plus: '3+ times',
        age: 'Age',
        under40: 'Under 40',
        over40: '40 and above',
        rating: 'Rating',
        score1: '1 point',
        score2: '2 points',
        score3: '3 points',
        score4plus: '4+ points',
        introduction: 'Introduction',
        notfilled: 'Not filled',
        filled: 'Filled',
        blacklist: 'Blacklist',
        notblacklisted: 'Not blacklisted',
        blacklisted: 'Blacklisted',
        blacklistL1: 'Blacklist L1',
        blacklistL2Plus: 'Blacklist L2+',
        excludetags: 'Exclude',
        includetags: 'Filter',
        alltags: 'All Tags',
        tagsLabel: 'Tags',
        currentFiltersLabel: 'Current filters:',
        tagFilterIncludeLabel: 'Tag filter:',
        tagFilterExcludeLabel: 'Tag exclusion:',
        selectedtags: 'Selected Tags',
        noSelectedTags: 'No tags selected',
        noAvailableTags: 'No tags available',
        notes: 'Notes',
        editage: 'Edit Age',
        systemage: 'System Age',
        actualage: 'Actual Age',
        adminNotePlaceholder: 'Admin notes',
        userRatingsModalTitle: '{userName}\'s User Ratings',
        userRatingsSectionTitle: 'User Ratings',
        blacklistStatusSectionTitle: 'Blacklist Status',
        positiveReviews: 'Positive Reviews',
        normalReviews: 'Normal Reviews',
        negativeReviews: 'Negative Reviews',
        noShow: 'No Show',
        lateArrival: 'Late Arrival',
        nonegativefeedback: 'No negative feedback yet',
        blacklistPhotoCount: 'Photo Count',
        blacklistInternalRating: 'Internal Rating',
        blacklistActualAge: 'Actual Age',
        blacklistMarkUp: 'Markup Flag',
        blacklistDislikes: 'Negative Reviews',
        blacklistAbsents: 'Absents',
        unmarked: 'Unmarked',
        loadBlacklistStatusFailed: 'Failed to load blacklist status',
        goodRates: 'Good Rates',
        refunded: 'Refunded',
        language: 'Language',
        nationality: 'Nationality',
        usingcitylanguage: 'Using City Language',
        notusingcitylanguage: 'Not Using City Language',
        totalUsersLabel: '(Total {count} users)'
    },

    // Rate Modal specific
    rate: {
        verificationfailed: 'Mark as failed real person verification',
        verificationfailedreported: 'Verification failure reported',
        ratingsaved: 'Rating saved',
        noverificationphoto: 'No verification photo provided',
        verificationFailedBadgeText: 'Verify\nFail',
        verificationfailedreporterror: 'Failed to report verification failure. Please try again.',
        pleaseselectrating: 'Please select a rating.',
        ratingsavefailed: 'Failed to save rating. Please try again.',
        confirmVerificationFailed: 'Are you sure you want to mark as failed real person verification?'
    },

    // Billing
    billing: {
        applicantcount: 'Attendance',
        newcustomer: 'New\nCustomer',
        returningcustomer: 'Returning\nCustomer',
        revenue: 'Revenue',
        repurchaserate: 'Repurchase Rate',
        customerratio: 'Customer Ratio',
        accounting: 'Accounting',
        filterSection: 'Filters',
        signupOverview: 'Signup Overview',
        participantList: 'Participant List',
        paymentStatusFilterSection: 'Participation Status Filters',
        attendedParticipants: 'Attended',
        refundedParticipants: 'Refunded',
        income: 'Income',
        stripeSettlementAmount: 'Stripe Settlement Amount (USD)',
        stripeSettlementTooltip: 'USD amount converted via Stripe',
        usd: 'USD',
        fee: 'Fee',
        tappayFee: 'TapPay Fee',
        stripeFee: 'Stripe Fee',
        tax: 'Tax',
        profit: 'Profit',
        captured: 'Captured',
        uncaptured: 'Uncaptured',
        uncapturedIncomeNote: 'Not including {count} uncaptured transactions',
        totalAttendance: 'Total Attendance',
        participant: 'Participant',
        groupID: 'Group',
        meetTime: 'Meet Time',
        promoCode: 'Promo Code',
        price: 'Payment Amount',
        usdAmount: 'Stripe Settlement Amount (USD)',
        paymentFee: 'Fee',
        paidTime: 'Paid Time',
        paymentStatus: 'Payment Status',
        refundStatus: 'Refund',
        payTime: 'Paid',
        refundTime: 'Refund',
        refunded: 'Refunded',
        noPaymentsFound: 'No payment records found for this date range.',
        noCanceledFeesFound: 'No refunded records found for this date range.',
        selectCityFirst: 'Please select a city first.',
        loadedPayments: 'Loaded {count}',
        cannotloaddata: 'Cannot load data',
        apierror: 'API Error'
    },

    // Promo Code
    promocode: {
        title: 'Add Promo Code',
        editTitle: 'Edit Promo Code',
        typeLabel: 'Type',
        promoType: 'Promo Code',
        publicType: 'Themed Table',
        promoCode: 'Promo Code (15 chars max)',
        promoCodeLabel: 'Promo Code (15 chars max)',
        publicCodeLabel: 'Themed Table Code (15 chars max)',
        promoCodePlaceholder: 'hello{rrr} or leave blank to auto-generate',
        generateCode: 'Generate Random Code',
        generateShare: 'Share Promo',
        generateComp: 'Compensation',
        generateFree: 'Free',
        formatDescription: 'Generate Random Code',
        formatExamples: '• Number random: hello{nnnn} → hello1325, {nnn} → 123, {nn} → 12, {n} → 1<br>• Alphanumeric random: hello{rrr} → hello3ar1, {rr} → a2, {r} → x<br>• User birth year: hello{yyyy} → hello1990, {yy} → 90<br>• Leave blank to auto-generate random format promo code<br><br>Share Promo: share + (YYM) + 3-digit alphanumeric random code<br>Compensation: comp + (YYM) + 3-digit alphanumeric random code<br>Free: free + (YYM) + 3-digit alphanumeric random code',
        selectCountry: 'Select Country',
        selectCity: 'Select City',
        timeSlot: 'Time Slot',
        expirationDate: 'Expiration Date',
        usageLimit: 'Usage Limit per Account',
        totalQuantity: 'Total Quantity (The limit is 255.)',
        unlimited: 'Unlimited',
        discountType: 'Discount Type',
        publicDiscountType: 'Themed Table Pricing Type',
        percentage: 'Percentage',
        fixedAmount: 'Fixed Amount',
        discount: 'Discount',
        publicDiscount: 'Price',
        publicPercentagePrefix: 'Original Price X',
        publicPercentageSuffix: '% = Sale Price',
        publicFixedPrefix: 'Original Price -',
        publicFixedSuffix: '= Sale Price',
        firstTimeOnly: 'Limited to first-time users',
        notes: 'Notes (Optional)',
        publicNotes: 'Themed Table Description',
        notesPlaceholder: 'Enter notes...',
        publicTitlePlaceholder: 'Enter themed table name',
        publicDetailsPlaceholder: 'Enter themed table introduction',
        generalNotesSection: 'General Notes',
        generalDetailsLabel: 'Notes',
        generalDetailsHint: '(max 100 characters)',
        addLocale: 'Add language +',
        selectLanguage: 'Select language',
        confirm: 'Confirm',
        noLocaleData: 'No locale data available.',
        localeRequired: 'Please select language first',
        add: 'Add',
        update: 'Update',
        cancel: 'Cancel',
        processing: 'Processing...',
        
        // Table headers
        edit: 'Edit',
        code: 'Promo Code',
        location: 'Location',
        status: 'Status',
        type: 'Type',
        value: 'Discount',
        currency: 'Currency',
        expiration: 'Expiration Time',
        firstTime: 'Limited to first-time users',
        perUser: 'Usage Limit per Account',
        totalLimit: 'Total Quantity',
        usedCount: 'Used Count',
        details: 'Details',
        
        // Messages
        addSuccess: 'Promo code added successfully!',
        updateSuccess: 'Promo code updated successfully!',
        addFailed: 'Failed to add promo code',
        updateFailed: 'Failed to update promo code',
        promoCodeRequired: 'Please enter promo code',
        countryRequired: 'Please select country',
        cityRequired: 'Please select city',
        expirationRequired: 'Please select expiration date',
        usageLimitInvalid: 'Usage limit per account must be greater than 0',
        totalQuantityInvalid: 'Total quantity must be greater than 0',
        percentageRangeInvalid: 'Percentage discount value must be between 1-100',

        noPromoCodesFound: 'No promo code data found',
        loadCountryFailed: 'Failed to load country promo codes',
        loadCityFailed: 'Failed to load city promo codes',
        promoCodeNotFound: 'The specified promo code was not found',
        loadDataFailed: 'Failed to load data',
        noCountriesAvailable: 'No countries available',
        noPermissionToEdit: 'No permission to edit',
        all: 'All',
        unexpiredFilter: 'Unexpired',
        expiredFilter: 'Expired',
        yes: 'Yes',
        no: 'No',
        active: 'Active',
        expired: 'Expired'
    },

    themetable: {
        title: 'Add Themed Table',
        editTitle: 'Edit Themed Table',
        codeLabel: 'Themed Table Code (15 chars max)',
        codePlaceholder: 'hello{rrr} or leave blank to auto-generate',
        generateCode: 'Generate Random Code',
        generateShare: 'Share Promo',
        generateComp: 'Compensation',
        generateFree: 'Free',
        formatDescription: 'Generate Random Code',
        formatExamples: '• Number random: hello{nnnn} → hello1325, {nnn} → 123, {nn} → 12, {n} → 1<br>• Alphanumeric random: hello{rrr} → hello3ar1, {rr} → a2, {r} → x<br>• User birth year: hello{yyyy} → hello1990, {yy} → 90<br>• Leave blank to auto-generate random format themed table code<br><br>Share Promo: share + (YYM) + 3-digit alphanumeric random code<br>Compensation: comp + (YYM) + 3-digit alphanumeric random code<br>Free: free + (YYM) + 3-digit alphanumeric random code',
        selectCountry: 'Select Country',
        selectCity: 'Select City',
        timeSlot: 'Time Slot (Optional)',
        expirationDate: 'Expiration Date',
        usageLimit: 'Usage Limit per Account',
        totalQuantity: 'Total Quantity (0 means unlimited; the limit is 255.)',
        unlimited: 'Unlimited',
        discountType: 'Themed Table Pricing Type',
        percentage: 'Percentage',
        fixedAmount: 'Fixed Amount',
        discount: 'Price',
        percentagePrefix: 'Original Price X',
        percentageSuffix: '% = Sale Price',
        fixedPrefix: 'Original Price -',
        fixedSuffix: '= Sale Price',
        firstTimeOnly: 'Limited to first-time users',
        notes: 'Themed Table Description',
        titleLabel: 'Name',
        titleHint: '(max 20 characters)',
        detailsLabel: 'Description',
        detailsHint: '(max 200 characters)',
        titlePlaceholder: 'Enter themed table name',
        detailsPlaceholder: 'Enter themed table introduction',
        generalNotesSection: 'General Notes',
        generalDetailsLabel: 'Notes',
        generalDetailsHint: '(max 100 characters)',
        addLocale: 'Add language +',
        selectLanguage: 'Select language',
        confirm: 'Confirm',
        localeRequired: 'Please select language first',
        add: 'Add Themed Table',
        update: 'Update',
        cancel: 'Cancel',
        processing: 'Processing...',
        edit: 'Edit',
        code: 'Themed Table Code',
        location: 'Location',
        status: 'Status',
        value: 'Price',
        expiration: 'Expiration Time',
        firstTime: 'Limited to first-time users',
        perUser: 'Usage Limit per Account',
        totalLimit: 'Total Quantity',
        usedCount: 'Used Count',
        details: 'Themed Table Description',
        addSuccess: 'Themed table added successfully!',
        updateSuccess: 'Themed table updated successfully!',
        addFailed: 'Failed to add themed table',
        updateFailed: 'Failed to update themed table',
        noThemeTablesFound: 'No themed table data found',
        loadCountryFailed: 'Failed to load country themed tables',
        loadCityFailed: 'Failed to load city themed tables',
        noCountriesAvailable: 'No countries available',
        noPermissionToEdit: 'No permission to edit',
        themeTableNotFound: 'The specified themed table was not found',
        loadDataFailed: 'Failed to load data',
        all: 'All',
        unexpiredFilter: 'Unexpired',
        expiredFilter: 'Expired',
        yes: 'Yes',
        no: 'No',
        active: 'Active',
        expired: 'Expired',
        scheduleManagementTab: 'Themed Table Schedule Management',
        cityManagementTab: 'Table Types',
        reload: 'Reload',
        actions: 'Actions',
        meetTypeID: 'Meet Type ID',
        meetTypeName: 'Type Identifier',
        markUp: 'Mark-up',
        category: 'category',
        localeCount: 'Locales',
        country: 'Country',
        city: 'City',
        available: 'Availability',
        availableOpen: 'Open',
        availableClosed: 'Closed',
        addCityMeetType: 'Add Themed Table',
        editCityMeetType: 'Edit Themed Table',
        cityMeetTypesSummary: 'City themed tables ({count})',
        loading: 'Loading...',
        loadedMeetTypes: 'Loaded {count} city themed tables',
        loadMeetTypesFailed: 'Failed to load city themed tables',
        selectCityFirst: 'Please select a city first',
        noMeetTypesFound: 'No themed tables are configured for this city',
        meetTypeFieldsRequired: 'Enter a type identifier and a non-negative mark-up with up to two decimal places',
        categoryRequired: 'Category must be 1 or 2',
        createMeetTypeSuccess: 'City themed table added successfully',
        createMeetTypeFailed: 'Failed to add city themed table',
        updateMeetTypeSuccess: 'City themed table updated successfully',
        updateMeetTypeFailed: 'Failed to update city themed table',
        addMeetTypeLocale: 'Add Themed Table Locale',
        editMeetTypeLocale: 'Edit Themed Table Locale',
        noLocaleConfigured: 'No locale content configured',
        locale: 'Locale',
        localeID: 'Locale ID',
        localeTitle: 'Display Title',
        localeDetails: 'Details',
        cityMeetType: 'City Themed Table',
        localeFieldsRequired: 'Complete the city themed table, locale, display title, and details',
        addMeetTypeLocaleSuccess: 'Themed table locale added successfully',
        addMeetTypeLocaleFailed: 'Failed to add themed table locale',
        updateMeetTypeLocaleSuccess: 'Themed table locale updated successfully',
        updateMeetTypeLocaleFailed: 'Failed to update themed table locale'
    },

    seasonpass: {
        selectCountry: 'Select Country',
        selectCity: 'Select City',
        filterActionsSection: 'Filters & Actions',
        statusFilterSection: 'Status Filter',
        summary: 'Accounting',
        purchasers: 'Purchasers',
        revenue: 'Revenue',
        usdRevenue: 'USD Revenue',
        fee: 'Fee',
        tax: 'Tax',
        profit: 'Profit',
        code: 'Season Pass Code',
        status: 'Status',
        discount: 'Amount',
        price: 'Payment Amount',
        usd: 'USD',
        usedCount: 'Used / Total',
        totalLimit: 'Total Limit',
        perUser: 'Usage Limit per Account',
        period: 'Period',
        payTime: 'Payment Time',
        expirationTime: 'Expiration Time',
        note: 'Purchaser',
        to: 'to',
        unexpiredFilter: 'Unexpired',
        expiredFilter: 'Expired',
        active: 'Active',
        expired: 'Expired',
        authorized: 'Authorized',
        captured: 'Captured',
        uncapturedStatus: 'Uncaptured',
        uncapturedRevenueNote: 'Excludes uncaptured transactions',
        captureTime: 'Capture Time',
        expiredBadge: 'Expired',
        usedUpBadge: 'Used up',
        startDate: 'Start date',
        endDate: 'End date',
        noSeasonPassesFound: 'No season pass data found',
        loadFailed: 'Failed to load season passes',
        emailListButton: 'Email List',
        noAvailableEmails: 'No emails available to download',
        emailListDownloaded: 'Downloaded email list ({count} emails)'
    },

    // Review
    review: {
        photo: 'Photo',
        photoVerification: 'Photo Verification',
        reverifyMode: 'Reverify',
        verificationSuccess: 'Verification Success',
        verificationFailed: 'Verification Failed',
        verificationUpdated: 'Photo verification updated',
        ageWithValue: 'Age:{age}',
        ageUnknown: 'Age:-',
        idLabel: 'ID: {id}',
        lastManagementVerification: 'Last management verification',
        lastUserVerificationUpload: 'Last verification photo upload',
        notePlaceholder: 'Enter a note...',
        selectCityFirst: 'Please select a city first.',
        noReviewData: 'No review data for this city.',
        loadReviewFailed: 'Unable to load review data for {city}.',
        citySelectorMissing: 'City selector not found, cannot load reviews.',
        ratingButtonsAria: 'Rating buttons'
    },

    // Notification
    notification: {
        directPromoCode: "Promo code (optional)",
        directNoPromoCode: "Do not use a promo code",
        directPromoLoading: "Loading promo codes…",
        directPromoEmpty: "No promo codes available for this region.",
        directPromoFailed: "Unable to load promo codes. Reopen this dialog to retry, or send without a promo code.",
        pushToThisUser: "Push to this user",
        directMissingResume: "This user has no Resume ID. Push is unavailable.",
        notifyResume: "Push to specific user",
        directContent: "Push content",
        directSend: "Send push",
        directSending: "Sending…",
        directRequired: "Enter a Resume ID and push content.",
        directSuccess: "Push request submitted",
        directFailed: "Push request could not be confirmed. Check the result before retrying.",

        title: 'Notifications',
        add: 'Add Content',
        content: 'Content',
        target: 'Target',
        type: 'Type',
        push: 'Push',
        message: 'Notification',
        email: 'Email',
        allUsers: 'All Users',
        newUsers: 'New Users',
        activeUsers: 'Active Users',
        language: 'Language',
        sendStatus: 'Send Status',
        sendTime: 'Send Time',
        all: 'All',
        sent: 'Sent',
        pending: 'Pending',
        selectCityFirst: 'Please select a city first.',
        selectCityForAdd: 'Please select a city first.',
        cannotLoadData: 'Cannot load notification data for city',
        citySelectorNotFound: 'City selector not found, cannot load notifications.',
        totalUsers: 'Total: {count} users',
        devices: 'Devices',
        view: 'View',
        none: 'None',
        allUsersAudience: 'All users',
        copyHint: 'Click to copy',
        invalidDataFormat: 'Invalid notification data format',
        gender: 'Gender',
        male: 'Male',
        female: 'Female',
        age: 'Age',
        underForty: 'Under 40',
        fortyAndOver: '40 or above',
        blacklist: 'Blacklist',
        blacklistL2OrAbove: 'L2 or above',
        rating: 'Rating',
        ratingFourOrAbove: '4 or above',
        signUps: 'Sign-ups',
        signUpsThreeOrAbove: '3 or above',
        includeTags: 'Include Tags',
        excludeTags: 'Exclude Tags',

        // Edit Page
        editTitle: 'Edit Content',
        country: 'Country',
        city: 'City',
        selectCountry: 'Select Country',
        selectCity: 'Select City',
        selectLanguage: 'Select Language',
        areaSection: 'Area',
        audienceSection: 'Audience',
        audienceLanguageHint: 'Will be sent to users who use {language}',
        languageSelectionSection: 'Language Selection',
        pushContentSection: 'Push Content',
        notificationDetailsSection: 'Notification Content',
        expandDetails: 'Expand',
        collapseDetails: 'Collapse',
        sendTimeSection: 'Send Time',
        formContent: 'Content',
        promoCode: 'Promo Code',
        selectPromoCode: 'No promo code',
        loadPromoCodesFailed: 'Failed to load promo codes',
        promoName: 'Promo Code',
        englishContent: 'English Content',
        localLanguage: 'Local Language',
        localContent: 'Local Content',
        contentLabelSuffix: ' Content',
        publishNotification: 'Publish notification at the same time',
        formSendTime: 'Send Time',
        sendNow: 'Send Immediately',
        sendScheduled: 'Scheduled Time',
        date: 'Date',
        hour: 'Hour',
        minute: 'Minute',
        second: 'Second',
        contentPlaceholder: 'Please enter notification content',
        aiSuggestBtn: 'AI Suggest',
        aiSuggestTooltip: 'AI suggested promotional push notification content',
        aiSuggestDetailsTooltip: 'AI suggested detailed promotional notification content',
        aiSuggestProcessing: 'Generating...',
        aiSuggestLanguageRequired: 'Please select a language before using AI suggestions',
        aiSuggestSuccess: 'AI suggested content has been filled in',
        aiSuggestFailed: 'Failed to generate AI suggested content',
        aiSuggestEmpty: 'AI did not return usable content',
        aiSuggestDetailsPushRequired: 'Please enter push content before generating notification details',
        aiSuggestDetailsSuccess: 'AI suggested notification details have been filled in',
        aiSuggestDetailsFailed: 'Failed to generate AI suggested notification details',
        aiSuggestDetailsFormatFailed: 'AI returned an invalid format. Please try again',
        promoNamePlaceholder: 'Please enter promo code',
        englishContentPlaceholder: 'Please enter English notification content',
        localContentPlaceholder: 'Please enter local-language notification content',
        cancel: 'Cancel',
        deleteDetails: 'Delete',
        addBtn: 'Add',
        updateBtn: 'Update',
        submitProcessing: 'Processing...',
        updateProcessing: 'Updating...',
        deleteProcessing: 'Deleting...',
        loadLanguageFailed: 'Load failed',
        loadLanguageOptionsFailed: 'Failed to load language options: {error}',
        loadPageDataFailed: 'Page initialization failed',
        missingRequiredParams: 'Required parameters are missing. Please return to the notification list and try again.',
        countryOrCitySelectorNotFound: 'Country or city selector not found',
        selectorInitTimeout: 'Selector initialization timed out. Please refresh the page.',
        testModeParamsLogged: 'Test mode: parameters checked; notification not sent',

        // Toasts
        cityRequired: 'Please select a city',
        languageRequired: 'Please select a language',
        contentRequired: 'Please enter notification content',
        contentTooLong: 'Content cannot exceed {limit} characters',
        promoNameRequired: 'Please enter promo code',
        englishContentRequired: 'Please enter English content',
        localLanguageRequired: 'Please select local language',
        localContentRequired: 'Please enter local content',
        dateRequired: 'Please select a send date',
        timeRequired: 'Please select a complete send time (hour, minute, second)',
        timeInvalid: 'Scheduled time must be later than the current time',
        addSuccess: 'Notification added successfully',
        addFailed: 'Failed to add notification',
        addFailedWithError: 'Failed to add notification: {error}',
        updateSuccess: 'Notification updated successfully',
        updateFailed: 'Failed to update notification',
        deleteDetailsSuccess: 'Notification content deleted',
        deleteDetailsFailed: 'Failed to delete notification content',
        noDetailsToDelete: 'No notification content to delete',
        notificationNotFound: 'Notification not found',
        notificationIDMissing: 'Notification was created, but the API did not return notificationID, so notification content could not be added',
        loadEditDataFailed: 'Failed to load notification data for editing',
        authError: 'Admin authentication information is incomplete'
    }
}; 
